import { useEffect } from "react";

/** The text direction of a locale: right-to-left for Arabic. */
export const directionOf = (locale: string | undefined): "rtl" | "ltr" =>
  locale?.startsWith("ar") ? "rtl" : "ltr";

/**
 * Keeps `dir` on <html> and <body> in step with the locale. _document sets
 * both on the server; a language switch is a client-side navigation, so the
 * first page's direction would otherwise stay on <html>, where Tailwind's
 * `rtl:` variants still match it and keep mirroring English pages.
 */
export const useDocumentDirection = (locale: string | undefined) => {
  useEffect(() => {
    const dir = directionOf(locale);
    document.documentElement.setAttribute("dir", dir);
    document.body.setAttribute("dir", dir);
  }, [locale]);
};
